import { gql } from "@apollo/client";

export const GET_COMPLICACIONES_COMBO = gql`
query complicacionByIdTipoModulo($idTipoModulo: Int!) {
    complicacionByIdTipoModulo(idTipoModulo: $idTipoModulo){
        idComplicacion
        descripcion
    }
}`;

export const parseComplicaciones = (complicaciones) =>
structuredClone(complicaciones).map((complicacion) => ({
  id: complicacion?.idComplicacion,
  displayName: complicacion?.descripcion
}));